import { donorRecipientConstants } from '../constants';
import { deleteParams, createParams, saveParams } from './base.reducers';

const name = 'donorRecipients';

const initialState = {
	saveLoading: 0,
	saveSuccess: false,
	deleteLoading: 0,
	allLoading: 0,

	donorRecipients: [],
	donorRecipientsById: {},
	donorRecipientProgresses: [],
	donorRecipientProgressesById: {},
};

export default (state = initialState, payload) => {
	const { type, data } = payload;
	switch (type) {
		// Save and edit donor recipients
		case donorRecipientConstants.SAVING_DONOR_RECIPIENT_REQUEST:
			return {
				...state,
				saveSuccess: false,
				saveLoading: state.saveLoading + 1
			};
		case donorRecipientConstants.SAVING_DONOR_RECIPIENT_SUCCESS:
			const { form } = data;
			return {
				...saveParams({ name, state, form }),
				saveLoading: state.saveLoading - 1,
				saveSuccess: true
			};
		case donorRecipientConstants.SAVING_DONOR_RECIPIENT_FAILURE:	
			return {
				...state,
				saveLoading: state.saveLoading - 1
			};
		// Delete donor recipients
		case donorRecipientConstants.DELETE_DONOR_RECIPIENT_REQUEST:
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		case donorRecipientConstants.DELETE_DONOR_RECIPIENT_SUCCESS:
			const id = data;
			return {
				...deleteParams({ name, state, id }),
				deleteLoading: state.deleteLoading - 1
			};
		case donorRecipientConstants.DELETE_DONOR_RECIPIENT_FAILURE:	
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		// Load donor recipients
		case donorRecipientConstants.LOAD_DONOR_RECIPIENTS_REQUEST:
			return {
				...state,
				allLoading: state.allLoading + 1,
			};
		case donorRecipientConstants.LOAD_DONOR_RECIPIENTS_SUCCESS:
			return {
				...createParams({ name, state, data: data.data }),
				allLoading: state.allLoading - 1
			};
		case donorRecipientConstants.LOAD_DONOR_RECIPIENTS_FAILURE:	
			return {
				...state,
				allLoading: state.allLoading - 1,
			};
		// Load donor recipient progresses
		case donorRecipientConstants.LOAD_DONOR_RECIPIENT_PROGRESSES_REQUEST:
		    console.log(state);
		    console.log(data);
			return {
				...state,
				allLoading: state.allLoading + 1,
			};
		case donorRecipientConstants.LOAD_DONOR_RECIPIENT_PROGRESSES_SUCCESS:
			return {
				...createParams({ name: "donorRecipientProgresses", state, data: data.data }),
				allLoading: state.allLoading - 1
			};
		case donorRecipientConstants.LOAD_DONOR_RECIPIENT_PROGRESSES_FAILURE:
			return {
				...state,
				allLoading: state.allLoading - 1,
			};
		// Send donor recipient progress update email
		case donorRecipientConstants.SEND_DONOR_RECIPIENT_PROGRESS_UPDATE_REQUEST:
			return {
				...state,
				saveSuccess: false,
				saveLoading: state.saveLoading + 1
			};
		case donorRecipientConstants.SEND_DONOR_RECIPIENT_PROGRESS_UPDATE_SUCCESS:
			return {
				...state,
				saveLoading: state.saveLoading - 1,
				saveSuccess: true,
			};
		case donorRecipientConstants.SEND_DONOR_RECIPIENT_PROGRESS_UPDATE_FAILURE:
			return {
				...state,
				saveLoading: state.saveLoading - 1,
			};
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/redux/reducers/donorRecipient.reducers.js